import {getData } from "../utils";

export async function getPendingRewards(account) {
  try {
    const response = await getData(`/api/v1/get_pending_rewards?account=${account}`);
    return response.data.reward;
  } catch (err) {
    return Promise.reject(err);
  }
}

export async function getVestedRewards(account) {
  try {
    const response = await getData(`/api/v1/get_vested_rewards?account=${account}`);
    return response.data.reward;
  } catch (err) {
    return Promise.reject(err);
  }
}

export async function getPossibleRewards(betAmount) {
  try {
    if(betAmount<=0)
    {
        return 0
    }
    const response = await getData(`/api/v1/get_possible_rewards?betAmount=${betAmount}`);
    return response.data.reward;
  } catch (err) {
    return Promise.reject(err);
  }
}
